<template>
  <div>
    <Header :title="title" hide-action />
    <div class="article-wrapper">
      <div class="article-title">
        {{ title }}
      </div>
      <div class="article-content" v-html="body" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import Api from '@/common/api';
import { namespace } from 'vuex-class';
const userModule = namespace('user');

@Component({
  components: {
    Header,
  },
})
export default class Article extends Vue {
  @userModule.State('isLogin') isLogin!: boolean;

  title = '';
  body = '';

  async created() {
    const getArticles = async () => {
      const res = await Api.getShowArticle({
        articleId: this.$route.params.id,
      });
      if (res.bizCode === 10000) {
        this.title = res.data.title;
        this.body = res.data.body;
      } else {
        this.$router.push({
          name: 'home',
        });
      }
    };
    if (this.isLogin) {
      getArticles();
    } else {
      const res = await Api.createAnnoymousUser();
      if (res.bizCode === 10000) {
        Api.setAnonymousToken(res.data);
        getArticles();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variable.scss';
.article-wrapper {
  padding: 14px 20px 33px;
  background-color: white;
  color: $article-content-text-color;
  background-color: $article-background;
  .article-title {
    @extend .text-bold;
    font-size: $size-m;
    padding: 17px 0;
    color: $article-title-color;
  }
  .article-content {
    @extend .text-regular;
    font-size: $size-m2;

    img {
      max-width: 80%;
    }

    a {
      color: $article-link-color;
    }
  }
}
</style>
